import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=8307e908&scoped=true"
import script from "./FormBlock.vue?vue&type=script&lang=js"
export * from "./FormBlock.vue?vue&type=script&lang=js"
import style0 from "./FormBlock.vue?vue&type=style&index=0&id=8307e908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8307e908",
  null
  
)

export default component.exports